


























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Enrollment from '../../../api/v2/models/enrollment'
import { checkMobile } from '../../utils/utils'
import { footerState } from '../../stores/footer'

@Component({})
export default class CourseMy extends Vue {
  isMobile: boolean = checkMobile()

  @Prop({ required: true })
  enrollment: Enrollment

  size = this.isMobile ? 40 : 70

  created() {
    footerState.setFooterDefault()
  }

  saveNavigationPath() {
    sessionStorage.setItem('previousPage', this.$route.path);
    this.$router.push(`/classroom/my-courses/${this.enrollment.course.id}`);
  }
}
